/**
 * @desc loadUserByAdapter
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<defs.appCenter.UserDto>;
export function request(body: defs.appCenter.Code, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/load/user`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
